import React from "react";

const NeoListItem = (props) => {
  return (<li className={`${props.extra ? props.extra : ""}`}>
    {props.children}
  </li>);
};

export default NeoListItem;